import React from 'react';
import Container from '../../../containers/master/courses/courseListContainer';

export default function () {
  return (
    <Container />
  );
}
